<template>
  <section class="flex">

      <header class="container-1">
          <!-- <h3 class="apanam">JALAGATA</h3> -->
          <h1>The Background
</h1>
      
      <img src="../../assets/underline.png" alt="">


      <h4>Yoga is vast and dense, difficult for kids to grasp. Plus, teachers don’t often know how <br> to make it appealing for little minds. In addition, parents often prefer certification <br> courses.They are unaware of the permanent changes that yoga brings about in <br> improving a child’s quality of life. <br> <br>
Most of all, finding any kids’ yoga classes for inspiration was tough, so we had to start <br> from scratch. </h4>
     
      </header>


<div>
      <img class="background1" src="../../assets/our_background.png" alt="">
</div>
   
  </section>


  <section class="flex2">

      <header class="container-2">
          <!-- <h3 class="apanam">JALAGATA</h3> -->
          <h1>Our Solution
</h1>
      
      <img src="../../assets/underline.png" alt="">


      <h4>Our founder, Sabrina, took cues from teaching her daughter. So, the classes are <br> designed for kids’ needs. They are easy to understand, interesting with games, <br> themes and challenges, music and learning. Stories are used to teach the asanas and <br> increase knowledge of Indian culture, philosophy and morals such as truthfulness, <br> non-stealing, non-violence etc. Breathwork, meditation and asanas better kids’ mind- <br> body connect. <br><br> 
Kids as young as three and as old as fifteen are engaged, whether they’re boys or girls. <br> The learning is continuous, spontaneous and free flowing. <br> <br> 
Yoga is also rooted in nature, which most kids love, so we deepen this connect. They <br> can imbibe the majesty of a lion through the lion pose or the grace of a bird through <br> pigeon pose. Our combination of Sanskrit and English keeps the kids on their toes, <br> sometimes literally! It’s holistic development, tailored to each child.</h4>
     
      </header>


<div>
      <img class="background1" src="../../assets/our_background1.png" alt="">
</div>
   
  </section>


<section class="flex3">
    <div class="container-3">
     <h1>The Future
</h1>
      
      <img src="../../assets/underline.png" alt="">


      <h4>We’ve become more digital this year, in order to be safe and reach out to kids across <br> the world. We are spreading the yogic way of life from Europe to Australia, one little <br> yogi at a time!</h4>

</div>
</section>


</template>

<script>
export default {

}
</script>

<style scoped>
.background1{
    border: 19px solid #60993E;
    border-radius: 46px;
        width: 100%;
    height: auto;
}
 .apanam{
color: #791E94;
    font-weight: 450;
 }  
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 70px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
button:hover{
    background-color: #ca6500;
}

h1{
    color: #791E94;
    
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
}
.flex{
    display: flex;
    justify-content: center;
    padding-top: 12rem;
        width: 90%;
    margin: auto;
    height: 1173px;
    flex-wrap: wrap;
}
.flex2{
    display: flex;
    justify-content: center;
        width: 90%;
    margin: auto;
    height: 1173px;
    flex-wrap: wrap;
}
.flex3{
    display: flex;
    justify-content: center;
        width: 90%;
    margin: auto;
    /* height: 1173px; */
    flex-wrap: wrap;
}
.container-1{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
        height: 340px;
}
.container-2{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
        height: 573px;
}
.container-3{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
        height: 340px;
}
body{
    background: #FFFFF2;
}



</style>>

